import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const SendIcon = ({ color = '#CCC', style = {}, size ='m24', ...attr }) => {
  return (
    <svg {...iconSizes[size]} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <rect opacity="1" height="28" width="28" rx="6" fill={color} />
      <path
        d="M6.48941 12.1226L18.6263 8.1244C19.4069 7.86722 20.1473 8.60941 19.8881 9.38944L15.8462 21.5569C15.5405 22.4772 14.2354 22.4674 13.9436 21.5426L12.3491 16.4897C12.2541 16.1886 12.0225 15.9501 11.7244 15.8463L6.4733 14.0167C5.57055 13.7022 5.58145 12.4217 6.48941 12.1226Z"
        fill="white"
      />
    </svg>

  );
};

export default SendIcon;
